module.exports = __webpack_public_path__ + "static/media/skip.4c2f0eb8.png";